export default __webpack_public_path__ + "static/media/img6.0b72e444.png";